import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonModule } from '@angular/common';
import { tap } from 'rxjs';
import { AuthHeaderComponent } from '../shared/auth-header/auth-header.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';

type AuthView = 'LOGIN' | 'REGISTER' | 'RECOVERY_PASSWORD';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  imports: [CommonModule, AuthHeaderComponent, LoginComponent, RegisterComponent, RecoveryPasswordComponent],
})
export class AuthComponent implements OnInit {
  private readonly aRoute = inject(ActivatedRoute);

  public view: AuthView = 'LOGIN';

  ngOnInit(): void {
    this.aRoute.data
      .pipe(
        tap((data: Params) => {
          if (data['module']) {
            this.view = data['module'] as AuthView;
          }
        })
      )
      .subscribe();
  }
}
